// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__yUjf-","footerLogo":"Footer_footerLogo__HEzk8","copyWrite":"Footer_copyWrite__ofsiI","copyWriteParam":"Footer_copyWriteParam__H8PXh","qr":"Footer_qr__MJqwe"};